export default {
	cancel: '取消',
	confirm: '確認',
	ok: '確定'
}
